export default "__VITE_ASSET__fAarKJuX__"